interface FieldShellProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
}

/** Stacked field layout: label, optional helper text, then the control. */
export default function FieldShell({
  title,
  description,
  children,
}: FieldShellProps) {
  return (
    <div className="space-y-1.5">
      {title && <div className="text-sm">{title}</div>}
      {description && (
        <div className="text-xs text-zinc-500">{description}</div>
      )}
      {children}
    </div>
  );
}
